import { css } from 'styled-components';
import { SloganProps } from './models';

export const Slogan = css<SloganProps>(({ theme }) => {
  return css`
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .slogan {
      text-align: center;
      color: ${theme.colors.primaryDeepBlue};
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 18px;
      line-height: 27px;

      > .special {
        color: ${theme.colors.primaryBright};
      }
    }

    > .powered-by-logo {
      width: 156px;
      height: 44px;
    }
  `;
});
